import ChatOptionButtons from './ChatOptionButtons'
import ChatTextInput from './ChatTextInput'
import PhotoUploadPanel from './PhotoUploadPanel'
import PictureOptionsGrid from './PictureOptionsGrid'
import { getLocalizedProductText } from './utils/productHelpers'

const ChatQuestionInput = ({
  questionStep,
  isPhotoStep,
  isButtonStep,
  isDone,
  typing,
  productsLoading,
  showHairPredictionRetryButton,
  showCamera,
  showManualHairTypeGrid,
  photoPreview,
  fileInputRef,
  hairTypeOptions,
  currentStepOptions,
  inputRef,
  input,
  onInputChange,
  onSend,
  onStartConversation,
  onCapture,
  onUploadClick,
  onTakePicture,
  onSelectHairType,
  onBackFromHairType,
  onHairTypeSelect,
  onRemovePhoto,
  onSendPhoto,
  onFileChange,
  onButtonAnswer,
  translations,
  language,
}) => {
  if (showHairPredictionRetryButton) {
    return null
  }

  if (questionStep === -1 && !typing) {
    return (
      <div className='chat-inputbar'>
        <div className='chat-input-inner'>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <button
              type='button'
              className='upload-send-btn'
              onClick={onStartConversation}
              disabled={typing}
              style={{ minWidth: 180 }}
            >
              {getLocalizedProductText({
                translations,
                language,
                keyPath: 'productFlow.getStarted',
                fallback: 'Get started',
              })}
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (isPhotoStep && !typing) {
    return (
      <PhotoUploadPanel
        showCamera={showCamera}
        showManualHairTypeGrid={showManualHairTypeGrid}
        photoPreview={photoPreview}
        fileInputRef={fileInputRef}
        hairTypeOptions={hairTypeOptions || []}
        onCapture={onCapture}
        onUploadClick={onUploadClick}
        onTakePicture={onTakePicture}
        onSelectHairType={onSelectHairType}
        onBackFromHairType={onBackFromHairType}
        onHairTypeSelect={onHairTypeSelect}
        onRemovePhoto={onRemovePhoto}
        onSendPhoto={onSendPhoto}
        onFileChange={onFileChange}
        translations={translations}
        language={language}
      />
    )
  }

  if (isButtonStep && !typing && !isPhotoStep && !isDone) {
    return (
      <div className='chat-inputbar'>
        <div className='chat-input-inner'>
          {currentStepOptions?.[0]?.image ? (
            <PictureOptionsGrid
              options={currentStepOptions || []}
              onSelect={(option) => onButtonAnswer(option.value, option.label)}
              disabled={typing || productsLoading}
            />
          ) : (
            <ChatOptionButtons
              options={currentStepOptions || []}
              onSelect={onButtonAnswer}
              disabled={typing || productsLoading}
            />
          )}
        </div>
      </div>
    )
  }

  if (
    questionStep !== -1 &&
    !isPhotoStep &&
    !isButtonStep &&
    !showHairPredictionRetryButton
  ) {
    return (
      <ChatTextInput
        inputRef={inputRef}
        value={input}
        onChange={onInputChange}
        onSend={onSend}
        disabled={typing || productsLoading}
        placeholder={
          isDone
            ? getLocalizedProductText({
                translations,
                language,
                keyPath: 'productFlow.recommendationsReady',
                fallback: 'Your recommendations are ready above',
              })
            : getLocalizedProductText({
                translations,
                language,
                keyPath: 'productFlow.typeAnswer',
                fallback: 'Type your answer…',
              })
        }
      />
    )
  }

  return null
}

export default ChatQuestionInput
